import { render } from "./level-6.vue?vue&type=template&id=f6ad18b6&ts=true"
import script from "./level-6.vue?vue&type=script&lang=ts"
export * from "./level-6.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__